import axios from 'axios';
import account from '@/api/v1/account';

// URL and endpoint constants
// Pinboard
const INDEX_URL = '/pinboard'; // GET

export default {
  // GET
  index(succ) {

	var params = new Object();
	
	var time= Math.floor(Date.now() / 1000);
	params['time']=time;
	
	axios.get(INDEX_URL, params ).then((response) => {
		
      succ(response.data);
    });
  },
  // GET
  show(succ, code) {
    const PINBOARD_ID = account.user.pinboard;
    // Parent needs to provide child code as param, teacher should not
	
	// this request is used for both pinboard detail and pinboard list
    const params = code ? { code } : { };
	
	var time= Math.floor(Date.now() / 1000);
	params['time']=time;
	
    if (account.user.authenticated && PINBOARD_ID) {
	axios.get(`${INDEX_URL}/${PINBOARD_ID}`, { params }).then((response) => {
        succ(response.data);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/pinboard.js